<template lang="pug">
    video(
            ref="video"
            preload="none"
            autoplay muted playsinline loop
            :poster="posterSource"
        )
            source(
                :src="videoSource"
                :type="videoType"
            )
</template>

<script>
export default {
    name: 'LazyVideo',
    props: {
        videoUrl: {
            type: String,
            required: true,
        },
        posterImageUrl: {
            type: String,
            default: '',
        },
        isLazy: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLazyLoaded: false,
        }
    },
    computed: {
        videoType() {
            if (this.videoUrl) return 'video/' + this.videoUrl.split('.').pop()
            return 'video/mp4'
        },
        videoSource() {
            if (this.isLazyLoaded) return this.videoUrl
            return undefined
        },
        posterSource() {
            if (this.isLazyLoaded) return this.posterImageUrl
            return undefined
        },
    },
    watch: {
        videoSource() {
            // Need to call the load function on the <video> element to get it to autoplay after src change
            this.$refs.video.load()
        },
    },
    beforeDestroy() {
        if (this.isLazy) this.$lazyload.unload(this.videoUrl)
    },
    created() {
        this.isLazyLoaded = !this.isLazy
    },
    mounted() {
        if (this.isLazy) this.$lazyload.load(this.$refs.video, this.videoUrl, this.lazyload)
    },
    methods: {
        lazyload() {
            this.isLazyLoaded = true
        },
    },
}
</script>
